<mat-card>
    <mat-card-header>
        <mat-card-title>Quickselect</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <img src="./assets/Human/Images/male_adult_average.PNG" style="width: 100%">
            <button (click)="setPos(0)" class="btn btn1">Button</button>
            <button (click)="setPos(1)" class="btn btn2">Button</button>
            <button (click)="setPos(2)" class="btn btn3">Button</button>
            <button (click)="setPos(3)" class="btn btn4">Button</button>
            <button (click)="setPos(4)" class="btn btn5">Button</button>
        </div>
    </mat-card-content>
</mat-card>
